"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/* eslint-disable */
/* tslint:disable */
var React = tslib_1.__importStar(require("react"));
var EditIcon = function (_a) {
    var size = _a.size, props = tslib_1.__rest(_a, ["size"]);
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "0 0 17 17", fill: "currentColor", width: size || "17", height: size || "17" }, props),
        React.createElement("path", { d: "M15.527 5.24l-1.58 1.583-3.781-3.787 1.58-1.582c.495-.494 1.356-.495 1.852 0l1.929 1.931c.51.511.51 1.344 0 1.855zm-8.758 8.768L5.264 12.5l3.978-3.982-.771-.773-3.977 3.983-1.505-1.506 6.405-6.414 3.781 3.786-6.406 6.413zm-5.153 1.376l.939-4.052 3.106 3.111-4.045.94zm14.682-12.77L14.37.681c-.908-.91-2.492-.909-3.397 0l-9.26 9.27L0 17l7.04-1.716 9.258-9.27a2.41 2.41 0 0 0 0-3.4z" })));
};
EditIcon.displayName = 'EditIcon';
exports.default = EditIcon;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=EditIcon.js.map